export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  category: string;
  author: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2025年最值得期待的日剧TOP10：经典回归与新作登场',
    excerpt: '2025年日剧市场迎来多部重量级作品，从经典续作到原创剧本，本文为你盘点今年最值得期待的十大日剧。',
    content: `<p>2025年对于日剧迷来说注定是丰收的一年。随着日本各大电视台纷纷加大制作投入，今年不仅有经典IP的回归，更有众多原创佳作即将登场。</p>
<h2>经典回归系列</h2>
<p><strong>《半泽直树3》</strong>无疑是今年最受瞩目的续作之一。堺雅人再次出演这位传奇银行家，据悉新一季将聚焦国际金融局势，半泽将面临来自全球金融巨头的挑战。制作方透露，本季将会有更多海外取景，制作规模全面升级。</p>
<p><strong>《深夜食堂》第六季</strong>延续了该系列一贯的温暖风格，但本季特别加入了更多年轻角色的故事线。从外卖骑手到自由职业者，深夜食堂的食客群体反映了当代日本社会的多元面貌。</p>
<h2>原创力作</h2>
<p>今年还有多部原创剧本值得关注。TBS电视台的《量子之恋》将科幻与爱情元素巧妙融合，讲述了一位量子物理学家与来自平行世界的恋人之间的奇幻故事。NHK大河剧《源氏物语新编》则以前所未有的视角重新诠释这部日本文学经典。</p>
<h2>漫改与小说改编</h2>
<p>漫改作品依然是日剧市场的重要组成部分。《葬送的芙莉莲》真人版已经确认将于夏季播出，选角一经公布便引发热议。《药屋少女的呢喃》电视剧版也在紧锣密鼓地制作中。</p>
<p>总的来说，2025年的日剧市场百花齐放，无论是喜欢职场剧、爱情剧、悬疑剧还是治愈系作品，观众都能找到自己的心头好。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20television%20drama%20collage%20with%20multiple%20popular%20shows%2C%20cinematic%20montage%2C%20warm%20lighting%2C%20professional%20entertainment%20aesthetic%2C%20Japanese%20urban%20night%20scene%20with%20TV%20screens&width=1200&height=630&seq=article-img-a1&orientation=landscape',
    date: '2025-07-28',
    category: '日剧',
    author: '日韩在线编辑部',
    tags: ['日剧', '推荐', '2025'],
  },
  {
    id: 'a2',
    title: '韩国综艺的全球征服之路：从Running Man到全球现象级',
    excerpt: '韩国综艺节目如何在过去十年间从亚洲走向世界？本文深度解析韩综的全球化策略与成功密码。',
    content: `<p>十年前，韩国综艺还只是东亚地区的小众爱好。而今天，Netflix、Disney+等国际平台上的韩国综艺节目已经成为全球观众的共同选择。这一转变背后，是韩国综艺产业数十年的积累与创新。</p>
<h2>从本土到全球的跨越</h2>
<p><strong>Running Man</strong>无疑是韩国综艺全球化的先行者。这档2010年开播的节目通过YouTube剪辑版的病毒式传播，在东南亚、中东甚至欧美积累了庞大的粉丝群体。节目的成功证明了：好的综艺内容可以跨越语言和文化的障碍。</p>
<p>2023年Netflix推出的《体能之巅：百人大挑战》更是将韩综推向了新高度。这档节目在全球90多个国家和地区登上Netflix热门榜单，成为首部登顶Netflix全球非英语节目榜的韩国综艺。</p>
<h2>成功密码：制作力与创新力</h2>
<p>韩国综艺的成功并非偶然。高度工业化的制作体系、才华横溢的PD团队、以及不断创新的节目形式，构成了韩综的核心竞争力。</p>
<p>与欧美综艺不同，韩综擅长将真人秀、游戏、脱口秀等多种形式融合在一起，创造出独特的观看体验。此外，韩综对"化学反应"的重视——即嘉宾之间的互动默契——也让节目充满了不可预测的趣味性。</p>
<h2>未来趋势</h2>
<p>随着全球流媒体平台对韩国内容的持续投入，2025年将有更多专为国际观众打造的韩国综艺问世。从恋爱观察到生存挑战，从音乐竞技到文化体验，韩国综艺的全球化故事才刚刚开始。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20production%20scene%20with%20colorful%20studio%20set%2C%20professional%20cameras%2C%20bright%20lighting%2C%20dynamic%20entertainment%20atmosphere%2C%20broadcast%20studio%20environment&width=1200&height=630&seq=article-img-a2&orientation=landscape',
    date: '2025-07-25',
    category: '韩综',
    author: '日韩在线编辑部',
    tags: ['韩综', '全球化', '分析'],
  },
  {
    id: 'a3',
    title: '日漫新番推荐：2025年夏季不容错过的五部动画',
    excerpt: '夏季新番季已经拉开帷幕，本文精选五部制作精良、剧情出色的新番作品，为你的追番列表提供参考。',
    content: `<p>2025年夏季新番季已经全面展开，本季共有超过50部新作播出。面对如此丰富的选择，我们为你精选了五部不容错过的作品。</p>
<h2>1. 《葬送的芙莉莲》第二季</h2>
<p>继第一季创下口碑与收视双丰收后，芙莉莲的第二段旅程正式启程。第二季将聚焦芙莉莲与菲伦、修塔尔克继续北上的冒险。制作组表示，本季的战斗场面将比第一季更加宏大，而情感刻画也将更加深入。</p>
<h2>2. 《怪兽8号》续篇</h2>
<p>日比野卡夫卡的故事继续展开。在经历了第一季的震撼登场后，续篇将深入揭示怪兽的起源之谜，同时卡夫卡与防卫队的羁绊也将面临新的考验。</p>
<h2>3. 《琉璃的宝石》</h2>
<p>这部讲述矿物爱好者日常的动画以其精美的作画和治愈的氛围获得了广泛好评。第二季将继续跟随琉璃的脚步，探索更多关于矿物与人生的故事。</p>
<h2>4. 《迷宫饭》第二季</h2>
<p>莱欧斯小队的迷宫美食冒险继续！第二季将深入迷宫更底层，遇到更多奇特的魔物——以及更多令人意想不到的美食创意。</p>
<h2>5. 《坂本日常》</h2>
<p>最强杀手退役后经营便利店的故事迎来动画化。原作漫画以其独特的幽默感和精彩的动作场面吸引了大量粉丝，动画版由MAPPA制作，品质值得期待。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20collage%20with%20various%20art%20styles%2C%20colorful%20characters%2C%20dynamic%20composition%2C%20vibrant%20colors%2C%20professional%20anime%20illustration%20quality&width=1200&height=630&seq=article-img-a3&orientation=landscape',
    date: '2025-07-22',
    category: '动漫',
    author: '日韩在线编辑部',
    tags: ['动漫', '新番', '推荐'],
  },
  {
    id: 'a4',
    title: '日韩影视作品中的美食文化：从屏幕到餐桌',
    excerpt: '日韩影视作品中频繁出现的美食场景不仅推动了剧情发展，更在全球范围内掀起了日韩美食热潮。',
    content: `<p>从《孤独的美食家》中井之头五郎大快朵颐的街头小店，到《请回答1988》里邻里之间分享家常菜的温馨场景，日韩影视作品中的美食元素已经成为一种独特的文化现象。</p>
<h2>日剧中的美食哲学</h2>
<p>日本影视作品中的美食往往承载着深厚的文化内涵。《深夜食堂》中的每一道菜都连接着一个人生故事，食物不仅是果腹之物，更是情感纽带。《小森林》则通过四季更替中的料理制作，展现了人与自然和谐共生的生活哲学。</p>
<p>《孤独的美食家》更是将"一人食"文化推向了极致。井之头五郎的每一次用餐都像一场仪式，从进门前的期待到每一口食物的品味，都让观众感受到了专注享受美食的乐趣。</p>
<h2>韩剧中的饮食文化</h2>
<p>韩国影视作品则更注重饮食中的社交属性。《请回答》系列中的邻里送菜文化、《一起用餐吧》中通过共餐建立的人际关系，都体现了韩国"共食"文化的核心价值。</p>
<p>此外，韩剧中频繁出现的炸鸡啤酒、辣炒年糕、烤肉等美食场景，也在全球范围内推动了韩国饮食文化的传播。据统计，《来自星星的你》播出后，中国市场的韩式炸鸡销量增长了超过200%。</p>
<h2>美食影视的全球化影响</h2>
<p>如今，越来越多的国际观众通过日韩影视作品了解和尝试日韩美食。Netflix等平台上的美食类日韩节目也获得了全球性的关注。美食，已经成为连接日韩文化与世界的重要桥梁。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20cuisine%20beautiful%20food%20photography%20with%20ramen%20and%20kimchi%2C%20warm%20lighting%2C%20appetizing%20presentation%2C%20cinematic%20food%20styling%2C%20cozy%20restaurant%20atmosphere&width=1200&height=630&seq=article-img-a4&orientation=landscape',
    date: '2025-07-18',
    category: '美食',
    author: '日韩在线编辑部',
    tags: ['美食', '文化', '影视'],
  },
];

export const faqItems = [
  {
    question: '日韩在线提供哪些类型的内容？',
    answer: '日韩在线平台汇聚了日本和韩国地区最全面的影视内容，涵盖日剧、韩剧、日本动漫、韩国综艺、日本综艺、日韩电影等多个分类。无论是热播新番、经典回顾，还是独家内容，您都可以在这里找到。我们的内容分为日韩国产在线、日韩激情在线、日韩精品在线、日韩久久在线、日韩高清在线等多个专区，满足不同观众的观看需求。',
  },
  {
    question: '日韩在线如何保证视频的高清画质？',
    answer: '日韩在线采用先进的视频编码技术和全球CDN加速网络，确保所有视频内容均支持1080P至4K超高清画质。我们的技术团队持续优化播放体验，智能自适应码率技术能够根据您的网络环境自动调整最佳画质，让您享受流畅不缓冲的观看体验。日韩高清在线专区更是专门收录了最高画质的视频内容。',
  },
  {
    question: '日韩在线是否需要注册才能观看？',
    answer: '日韩在线目前面向所有用户免费开放，无需注册即可浏览和观看全站内容。我们致力于为广大日韩影视爱好者提供最便捷的观看体验。如果您希望获得个性化推荐和收藏功能，可以选择免费注册成为会员。',
  },
  {
    question: '日韩在线的内容更新频率如何？',
    answer: '日韩在线保持每日更新，与日本、韩国播出的最新剧集和综艺保持同步。热门番剧和综艺节目通常在播出后的24小时内上线中文字幕版本。您可以通过首页的「最近更新」板块或关注我们的资讯推送，第一时间获取最新内容上线通知。',
  },
  {
    question: '日韩在线的视频支持哪些设备观看？',
    answer: '日韩在线全面支持PC端、平板端和手机端观看，适配主流浏览器（Chrome、Safari、Edge、Firefox等）和操作系统。我们的响应式网页设计确保在不同设备上都能获得最佳的观看体验。无论您是在家中使用电脑，还是外出时使用手机，都可以随时随地畅享日韩视频。',
  },
  {
    question: '日韩精品在线专区和日韩国产在线专区有什么区别？',
    answer: '日韩精品在线专区精选高品质、高口碑的日韩影视作品，包括获奖影片、高分剧集和制作精良的大制作，适合追求内容深度的观众。日韩国产在线专区则聚焦于日本和韩国本土原创内容，涵盖热门新番、经典老剧和人气综艺，内容类型更加丰富多元。两个专区互为补充，为不同口味的观众提供了多样化的选择。',
  },
];